(function() {
	'use strict';

	angular.module('quantixApp').controller(
			'ProductSectionConfigController', ProductSectionConfigController);

	ProductSectionConfigController.$inject = [ '$filter',
			'ProductSectionConfigService', '$scope','$timeout' ];

	function ProductSectionConfigController(filter,
			ProductSectionConfigService, $scope,$timeout) {
		var moduleSectionGrid = '';
		var CheckBoxRenderer, CheckBoxHeaderRenderer, uiUtil = flexiciousNmsp.UIUtils, flxConstants = flexiciousNmsp.Constants;
		$scope.count = 1;
		$scope.disabled = false;
		$scope.change = false;
		

		$scope.getModuleAndSectionData = function() {
			ProductSectionConfigService
					.getModuleAndSectionData()
					.then(
							function(data) {
								
								$scope.results = data;
								 $timeout(
						    				function() {				
							if($scope.products!=undefined){	
								$scope.results[0].productName1 = $scope.products[0].productName;
								$scope.results[0].productName2 = $scope.products[1].productName;
								$scope.results[0].productName3 = $scope.products[2].productName;
								$scope.results[0].productName4 = $scope.products[3].productName;
								$scope.results[0].productName5 = $scope.products[4].productName;
								$scope.results[0].productName6 = $scope.products[5].productName;
								$scope.results[0].productName7 = $scope.products[6].productName;
								$scope.results[0].productName8 = $scope.products[7].productName;
								$scope.results[0].productName9 = $scope.products[8].productName;
								$scope.results[0].productName10 = $scope.products[9].productName;
								$scope.results[0].productName11 = $scope.products[10].productName;
								$scope.results[0].productName12 = $scope.products[11].productName;
								$scope.results[0].productName13 = $scope.products[12].productName;
								$scope.results[0].productName14 = $scope.products[13].productName;
								$scope.results[0].productName15 = $scope.products[14].productName;
								$scope.results[0].productName16 = $scope.products[15].productName;
								$scope.results[0].productName17 = $scope.products[16].productName;
								$scope.results[0].productName18 = $scope.products[17].productName;
								$scope.results[0].productName19 = $scope.products[18].productName;
								$scope.results[0].productName20 = $scope.products[19].productName;
								$scope.results[0].productName21 = $scope.products[20].productName;
								$scope.results[0].productName22 = $scope.products[21].productName;
								$scope.results[0].productName23 = $scope.products[22].productName;
								$scope.results[0].productName24 = $scope.products[23].productName;
								
								$scope.moduleSectionGridData = {
										dataProvider : $scope.results,
										delegate : $scope

									};
							}}, 400);	
								
							}, function(errordata) {
								console.log("Some thing went wrong!");
							});

		}

		$scope.getProductListData = function() {
			ProductSectionConfigService.getProductList().then(
					function(data) {
						$scope.products = data;
					
					});
					

		}
		$scope.getModuleAndSectionData();
		$scope.getProductListData();

		$scope.moduleSectionGridCompletion = function(event) {
			moduleSectionGrid = event.target;
			moduleSectionGrid.validateNow();
		};
		
		CheckBoxRenderer = function() {
			//make sure to call constructor
			flexiciousNmsp.UIComponent.apply(this, [ "input" ]);//second parameter is the tag name for the dom element.
			this.domElement.type = "checkbox"; //so our input element becomes a checkbox;

			this.data = null;

			this.addEventListener(this, flxConstants.EVENT_CHANGE,
					this.onChange);
		};
		$scope.itemRenderersCheckBoxRenderer = CheckBoxRenderer;
		CheckBoxRenderer.prototype = new flexiciousNmsp.UIComponent();
		CheckBoxRenderer.prototype.typeName = CheckBoxRenderer.typeName = 'CheckBoxRenderer';
		CheckBoxRenderer.prototype.getClassNames = function() {
			return [ "CheckBoxRenderer", "UIComponent" ];
		};

		CheckBoxRenderer.prototype.setData = function(val) {
			flexiciousNmsp.UIComponent.prototype.setData.apply(this, [ val ]);
			var cell = this.parent;
			var column = cell.getColumn();
			this.domElement.checked = this.data[column.getDataField()];

		};

		CheckBoxRenderer.prototype.onChange = function(evt) {

			var cell = this.parent; //this is an instance of FlexDataGridDataCell (For data rows)
			var column = cell.getColumn();//this is an instance of FlexDataGridColumn.

			this.data[column.getDataField()] = this.domElement.checked;//we use the dom element to wire back the value to the data object.
			$scope.change = true;
		};

		CheckBoxHeaderRenderer = function() {
			flexiciousNmsp.UIComponent.apply(this, [ "label" ]);//second parameter is the tag name for the dom element.
			this.data = null;
		};
		$scope.checkBoxHeaderRenderer = CheckBoxHeaderRenderer; //add to name space
		CheckBoxHeaderRenderer.prototype = new flexiciousNmsp.UIComponent(); //setup hierarchy
		CheckBoxHeaderRenderer.prototype.typeName = CheckBoxHeaderRenderer.typeName = 'CheckBoxHeaderRenderer';//for quick inspection
		CheckBoxHeaderRenderer.prototype.getClassNames = function() {
			return [ "CheckBoxHeaderRenderer", "UIComponent" ]; //this is a mechanism to replicate the "is" and "as" keywords of most other OO programming languages
		};
		CheckBoxHeaderRenderer.prototype.setText = function(val) {

		};

		CheckBoxHeaderRenderer.prototype.setData = function(val) {
			flexiciousNmsp.UIComponent.prototype.setData.apply(this, val);
			var cell = this.parent;
			var column = cell.getColumn().dataField;
			if (this.data["productName" + $scope.count] != undefined)
				this.domElement.innerHTML = this.data["productName"
						+ $scope.count];
			this.domElement.id = $scope.count;
			//  while($scope.count==23)
			$scope.count++;
		};

		/*$scope.updateFlagForModuleAndSection = function() {
			if ($scope.change) {
				ProductSectionConfigService.saveModuleAndSectionFlag(
						moduleSectionGrid.getDataProvider()).success(function(result) {
							$scope.disabled=true;
						
				}).error(function(e) {
					$scope.disabled=true;
					$scope.errorMessage="Cannot update or save the record."
				});

			}
		}
		}*/
	}

})();
